import { Injectable } from '@angular/core';
import {AngularFireDatabase} from "@angular/fire/database";
import {AuthService} from "../security/auth.service";
import {forEach} from "@angular/router/src/utils/collection";
import {Court} from "./court";
import {Observable, of} from "rxjs";
import {Fieldname} from "./fieldname";

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  private tenantsPath = '/tenants';
  private fieldsPath = '/fields';

  private output: Court[] = [];


  constructor(private db: AngularFireDatabase, private authService: AuthService) { }

  timeout(ms): Promise<any> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // @ts-ignore
  async getCourts( tenantId: number, clubId: string ): Promise<Court[]> {
    //console.log(`tenantId: ${tenantId}, clubId: ${clubId}`);
    let courtList: Court[] = [];

    await this.db.object(`${this.tenantsPath}/${tenantId}`).query.once( 'value').then( cts => {
        if ( cts.val() ) {
          let keys = [];
          let val = [];

          if ( cts.val() ) {
            keys = Object.keys(cts.val().courts);
            val = cts.val().courts;
          }

          //console.log(`keys: ${keys}`);
          //console.log(cts.val());

          for ( const key of keys ) { // key is string. convert to number before using in a court class
            //console.log(`processing court ${key}...`);
            if ( val[key] ) {
              let tenantRecord = val[key];
              //console.log(`val[${key}]: ${JSON.stringify(tenantRecord)}`);
              let currentFieldId = tenantRecord.fieldId;
              let currentUseSunset: boolean = tenantRecord.useSunset;

              const fieldPath = `${this.fieldsPath}/${clubId}/${currentFieldId}`;
              //console.log(fieldPath);
              this.db.object(fieldPath).query.once('value').then( fld => {
                if ( fld.val() ) {
                  //console.log(fld.val());

                  let currentName = fld.val().name;
                  const newCourt = new Court( Number(key), currentFieldId, currentUseSunset, currentName);
                  //console.log( newCourt );
                  courtList.push(newCourt);
                }
              });
            }
          }
        }
      }).then( d => {
        //console.log('done');
    });
    return courtList;
  }

}

